import { useEffect } from "react";

const ClickSpark = ({
  color = "#ee2d2b",
  size = 6,
  count = 6,
  duration = 400,
}) => {
  useEffect(() => {
    const handleClick = (e) => {
      for (let i = 0; i < count; i++) {
        const spark = document.createElement("span");
        spark.className = "click-spark";
        spark.style.left = `${e.clientX}px`;
        spark.style.top = `${e.clientY}px`;
        spark.style.background = color;
        spark.style.width = spark.style.height = `${size}px`;
        spark.style.setProperty("--duration", `${duration}ms`);
        spark.style.setProperty("--angle", `${Math.random() * 360}deg`);

        document.body.appendChild(spark);
        setTimeout(() => spark.remove(), duration);
      }
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, [color, size, count, duration]);

  return null;
};

export default ClickSpark;
